import type { AmazonModuleConfig } from "@/ts/module";

export const amazonHomepage: Pick<AmazonModuleConfig, "adSizesAmazon"> = {
	adSizesAmazon: {
		"div-gpt-ad-top-slot": [
			[970, 250],
			[728, 90],
			[320, 100],
			[320, 50],
			[300, 100],
			[300, 50],
		],
		"div-gpt-ad-rh-slot": [
			[300, 250],
			[300, 600],
			[120, 600],
		],
		"div-gpt-ad-section-slot-1": [
			[970, 250],
			[728, 90],
			[970, 90],
			[960, 90],
			[960, 250],
			[300, 250],
		],
		"div-gpt-ad-section-slot-2": [
			[970, 250],
			[728, 90],
			[970, 90],
			[960, 90],
			[960, 250],
			[300, 250],
		],
		"div-gpt-ad-section-slot-3": [
			[970, 250],
			[728, 90],
			[970, 90],
			[960, 90],
			[960, 250],
			[300, 250],
		],
		"div-gpt-ad-section-slot-4": [
			[970, 250],
			[728, 90],
			[970, 90],
			[960, 90],
			[960, 250],
			[300, 250],
		],
		"div-gpt-ad-bottom-slot": [[728, 90]],
		"div-gpt-ad-sticky-bottom-banner": [
			[320, 100],
			[320, 50],
			[300, 100],
			[300, 50],
		],
		"div-gpt-ad-skyscraper-left-slot": [
			[120, 600],
			[160, 600],
			[300, 250],
			[300, 600],
		],
		"div-gpt-ad-skyscraper-right-slot": [
			[120, 600],
			[160, 600],
			[300, 250],
			[300, 600],
		],
	},
};
